import { type ProductIngredientModifications } from '../../../state';
import {
  type FilteredIngredientModifications,
  type FilteredIngredientModificationsKind,
} from '../../../types';

export const getSelectedQuantityByKind = (
  params: GetSelectedQuantityByKindParams,
) => {
  const { active, ingredientKindName } = params;

  return active
    .filter(({ kind }) => kind === ingredientKindName)
    .reduce((accumulator, { quantity: ingredientQuantity }) => {
      accumulator += ingredientQuantity ?? 0;

      return accumulator;
    }, 0);
};

export const getFormattedQuantityByKind = (
  params: GetFormattedQuantityByKindParams,
) => {
  const { ingredientKindName, ingredientsModifications } = params;

  const key = ingredientKindName as keyof FilteredIngredientModifications;
  const ingredient = ingredientsModifications[key];
  const maxCount = ingredient?.maxAggregateQuantity ?? 0;
  const selectedCount = getSelectedQuantityByKind(params);

  return `${selectedCount}/${maxCount}`;
};

type GetSelectedQuantityByKindParams = {
  active: ProductIngredientModifications['active'];
  ingredientKindName: FilteredIngredientModificationsKind;
};

type GetFormattedQuantityByKindParams = {
  active: ProductIngredientModifications['active'];
  ingredientKindName: FilteredIngredientModificationsKind;
  ingredientsModifications: Partial<FilteredIngredientModifications>;
};
